// calculate the size (in radians) of the given radius (in meters)
//
// See https://en.wikipedia.org/wiki/Latitude#Length_of_a_degree_of_latitude:
//
//                    π a (1 - e²)
// deltaLat(φ) = -----------------------
//                                   3/2
//                180° (1 - e² sin² φ)
//
//                       π a cos φ
// deltaLong(φ) = ------------------------
//                                     1/2
//                 180° (1 - e² sin² φ)
//
// with
//   a = 6378137.0 m
//   b = 6356752.3142 m
//
//       a² - b²
//   e² = -------
//          a²

// some math shortcuts
const π = Math.PI;
const pow = Math.pow;
const deg2rad = (deg) => deg * π / 180;
const sin = (deg) => Math.sin(deg2rad(deg));
const cos = (deg) => Math.cos(deg2rad(deg));

// constants for earth wgs84 ellipsoid
const a = 6378137.0;
const b = 6356752.3142;
const e2 = (a*a - b*b) / (a*a);

// calculate distance (in meters) for 1° of latitude at given latitude φ
const deltaLatitude = (φ) => 
	( π * a * (1 - e2) )
	/
	( 180 * pow((1 - e2 * pow(sin(φ), 2)), 3/2) );

// calculate distance (in meters) for 1° of longitude at given latitude φ
const deltaLongitude = (φ) =>
	( π * a * cos(φ) )
	/
	( 180 * pow((1 - e2 * pow(sin(φ), 2)), 1/2) );

// calculate size in latitude/longitude at given latitude φ for circle of radius (in meters)
const circle = (φ, radius) => ({
	latitude: radius / deltaLatitude(φ),
	longitude: radius / deltaLongitude(φ)
});

export {
	circle
}